export default __webpack_public_path__ + "static/media/thick.a77559c0.png";